<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="13"
    height="13"
    viewBox="0 0 13 13"
    fill="none"
  >
    <line
      x1="1.99234"
      y1="2.0625"
      x2="10.8285"
      y2="10.8987"
      stroke="#212121"
      stroke-width="2"
      stroke-linecap="round"
    />
    <line
      x1="1.56641"
      y1="10.8983"
      x2="10.6524"
      y2="1.81226"
      stroke="#212121"
      stroke-width="2"
      stroke-linecap="round"
    />
  </svg>
</template>

<script>
export default {
  name: 'RemoveX',
};
</script>
